const STATS = [
  { icon: 'ri-file-certificate-line', value: '8,400+',      label: 'Certificates Acquired'       },
  { icon: 'ri-group-line',            value: '1,200+',      label: 'Active Member Portfolios'    },
  { icon: 'ri-percent-line',          value: '14.2%',       label: 'Average Annual Return'       },
  { icon: 'ri-map-2-line',            value: 'All 50',      label: 'States Covered Nationwide'   },
  { icon: 'ri-shield-check-line',     value: '97%',         label: 'Acquisition Success Rate'    },
];

export default function StatsBar() {
  return (
    <section className="bg-surface-2 border-y border-white/5 py-10">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-8">
          {STATS.map((s) => (
            <div key={s.label} className="flex flex-col items-center text-center gap-3">
              <div className="w-10 h-10 flex items-center justify-center rounded-xl border border-gold/20 bg-gold/8">
                <i className={`${s.icon} text-gold text-lg`} />
              </div>
              <div>
                <p className="font-playfair font-bold text-white text-2xl leading-tight">{s.value}</p>
                <p className="text-white/35 text-xs mt-1 leading-tight">{s.label}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
